(() => {
  const controllers = new WeakMap();
  function mount(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    const {signal} = controller;
    const observers = [];
    controllers.set(root, {controller, observers});
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-coffee-open]');
      if (trigger) {
        const dialog = root.querySelector('#' + trigger.dataset.coffeeOpen);
        if (dialog && !dialog.open) {
          dialog.showModal();
          dialog.querySelector('.coffee-dialog__layout').scrollTop = 0;
          dialog.querySelector('.coffee-dialog__close').focus({preventScroll: true});
        }
      }
      const close = event.target.closest('.coffee-dialog__close');
      if (close) close.closest('dialog').close();
      if (event.target.matches('dialog')) {
        const box = event.target.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
      }
      const anchor = event.target.closest('a[href^="#"]');
      if (anchor) {
        const menu = anchor.closest('details');
        if (menu) menu.open = false;
        if (anchor.matches('.skip-link')) root.querySelector('#kawy').focus({preventScroll: true});
      }
    }, {signal});
    root.querySelectorAll('.coffee-steam').forEach(steam => {
      const section = steam.closest('section');
      const button = section.querySelector('.morning-hero__motion');
      let visible = false;
      let playing = true;
      const sync = () => { steam.dataset.active = String(visible && playing && !document.hidden); };
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); });
      observer.observe(section);
      observers.push(observer);
      document.addEventListener('visibilitychange', sync, {signal});
      button.addEventListener('click', () => {
        playing = !playing;
        button.setAttribute('aria-pressed', String(playing));
        button.title = playing ? root.dataset.steamPause : root.dataset.steamResume;
        button.querySelector('path').setAttribute('d', playing ? 'M9 6v12M15 6v12' : 'm9 5 10 7-10 7V5Z');
        sync();
      }, {signal});
    });
  }
  document.querySelectorAll('[data-lorveni-morning]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-lorveni-morning]').forEach(mount));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-lorveni-morning]').forEach(root => {
    const state = controllers.get(root);
    state?.controller.abort();
    state?.observers.forEach(observer => observer.disconnect());
    controllers.delete(root);
  }));
})();
